module.exports = __webpack_public_path__ + "img/icon-shipin2.aac4b11a.png";